module.exports = __webpack_public_path__ + "static/media/avatar_28.477d5fd1.svg";